import Vue from 'vue';
import DropDownUp from '@/components/functional/DropDownUp';

Vue.component('mj-drop-down-up-transition', DropDownUp);
